export default function writeMileageSlug (mileage, mileageSlugUnit = '-km') {
    if (isNaN(mileage)) return mileage
	return `${mileage}${mileageSlugUnit}`
}